import React, {FC} from 'react';

import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {buildTeammateDisplayName} from '../../../../../../helpers/modelHelpers';
import {TeammateModel} from '../../../../../../models/api/teammateModel';
import {TeammateOnlineStatusesEnum} from '../../../../../../store/data/teammates/onlineTeammatesSelectors';
import {DropdownItemBadges} from '../../../../../common/dropdowns/dropdownItemBadges';
import {DropdownItemTeammateAvatarWithStatus} from '../../../../../common/dropdowns/dropdownItemTeammateAvatarWithStatus';

/*
 * Props.
 */

interface AssignDropdownItemProps extends DropdownItemProps {
  teammate: TeammateModel;
  isTeamMember: boolean;
  onlineStatus: TeammateOnlineStatusesEnum;
  isAssignee: boolean;
  isUser: boolean;
}

/*
 * Component.
 */

export const AssignDropdownItem: FC<AssignDropdownItemProps> = (props) => {
  const {teammate, isAssignee, onlineStatus, isTeamMember} = props;
  const {isAvailable} = teammate;

  return (
    <DropdownItem {...props} isChecked={isAssignee}>
      <DropdownItemTeammateAvatarWithStatus teammate={teammate} onlineStatus={onlineStatus} />
      <DropdownItemContent isChecked={isAssignee}>{buildTeammateDisplayName(teammate)}</DropdownItemContent>
      <DropdownItemBadges
        isUnavailable={!isAvailable}
        isNonTeamMember={!isTeamMember}
        isUnverified={teammate.isUnverified}
        renderAsSecondaryContent
      />
    </DropdownItem>
  );
};
